import { Stomp } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

let stompClient = null;

export const connectWebSocket = (onConfigUpdate) => {
    if (stompClient && stompClient.connected) {
        console.log("WebSocket ya está conectado. No se crearán nuevas suscripciones.");
        return; // Evita duplicar la conexión y suscripciones
    }

    // Conexión para el WebSocket
    const rawSocketUrl = process.env.REACT_APP_API_WHATSAPP_CONFIGS_SOCKET_ROUTE;
    const socketUrl = (typeof window !== 'undefined' && window.location.protocol === 'https:' && rawSocketUrl?.startsWith('http://'))
        ? rawSocketUrl.replace('http://', 'https://')
        : rawSocketUrl;
    const socket = new SockJS(`${socketUrl}`);
    stompClient = Stomp.over(socket);

    // Obtener el token JWT del localStorage
    const token = localStorage.getItem('authToken');
    const headers = {
        Authorization: `Bearer ${token}`
    };

    stompClient.connect(headers, () => {
        console.log("Conectado al WebSocket");

        // Suscripción a notificaciones privadas
        stompClient.subscribe("/user/queue/notificaciones", (message) => {
            const notificationMessage = parseMessageBody(message);
            toast.info(<div dangerouslySetInnerHTML={{ __html: notificationMessage }} />, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        });

        // Suscribe a configuraciones de delivery
        stompClient.subscribe("/topic/configDeliveryCommon", (message) => {
            const deliveryConfig = JSON.parse(message.body);
            //console.log("config Delivery: ", deliveryConfig);

            onConfigUpdate(prevConfig => ({
                ...prevConfig,
                deliveryCommon: deliveryConfig
            }));
        });

        // Suscribe a configuraciones de delivery custom
        stompClient.subscribe("/topic/configDeliveryCustom", (message) => {
            const deliveryConfig = JSON.parse(message.body);

            onConfigUpdate(prevConfig => ({
                ...prevConfig,
                deliveryCustom: deliveryConfig
            }));
        });

        // Suscribe a configuraciones de whatsapp
        stompClient.subscribe("/topic/configWhatsapp", (message) => {
            const config = JSON.parse(message.body);
            //console.log("config Whatsapp: ", config);
            onConfigUpdate(config);
        });

        // Suscribe a alertas de bajo stock privadas por usuario
        stompClient.subscribe("/user/queue/lowStockAlerts", (message) => {
            const alertMessage = parseMessageBody(message);

            const location = window.location.pathname; // Obtén la ruta actual directamente
            const excludedRoutes = ["/", "/carta", "/estadoDelPedido", "/notfound"]; // Rutas excluidas

            if (!excludedRoutes.includes(location)) {
                toast.warning(alertMessage, {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    style: {
                        backgroundColor: 'rgb(78, 176, 223)',
                        color: 'white',
                        fontWeight: 'bold',
                    },
                });
            }
        });

        // Suscribe a alertas de vencimientos de productos
        stompClient.subscribe("/user/queue/expirationProductAlerts", (message) => {
            const alertMessage = parseMessageBody(message);

            const location = window.location.pathname; // Obtén la ruta actual directamente
            const excludedRoutes = ["/", "/carta", "/estadoDelPedido", "/notfound"]; // Rutas excluidas

            if (!excludedRoutes.includes(location)) { // Muestra la alerta si la ruta no está excluida
                toast.warning(<div dangerouslySetInnerHTML={{ __html: alertMessage }} />, {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    style: {
                        backgroundColor: 'rgb(223,78,78)',
                        color: 'white',
                        fontWeight: 'bold',
                    },
                });
            }
        });

    });
};

const parseMessageBody = (message) => {
    let alertMessage = message.body;
    if (message.isBinaryBody) {
        const decoder = new TextDecoder("utf-8");
        alertMessage = decoder.decode(message._binaryBody);
    }
    return alertMessage;
};

// Función auxiliar para obtener el token y enviarlo con headers
const sendMessage = (destination, params) => {
    if (stompClient && stompClient.connected) {
        const token = localStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`
        };

        stompClient.send(
            destination, // Ruta destino
            headers,     // Headers con el token
            JSON.stringify(params) // Cuerpo del mensaje
        );
    } else {
        console.error('WebSocket no está conectado');
    }
};

export const sendConfigUpdateWhatsapp = (params) => {
    sendMessage(`/app/updateConfigWhatsapp`, params);
};

export const sendConfigUpdateDelivery = (params) => {
    sendMessage(`/app/updateConfigDeliveryCommon`, params);
};

export const sendConfigUpdateDeliveryCustom = (params) => {
    sendMessage(`/app/updateConfigDeliveryCustom`, params);
};

